
import { Vue, Component, Ref, Watch, Model } from 'vue-property-decorator';
import { quillEditor } from 'vue-quill-editor';
import axios from 'axios';
import { BASE_URL } from '@/common/constant';
import lazyInject from '@/di';
import UserService from '@/services/user.service';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Quill from 'quill';
import ImageResize from 'quill-image-resize-module';

Quill.register('modules/imageResize', ImageResize);

// 使用 @Component 装饰器来声明 Vue 组件及其子组件
@Component({
  name: 'RichTextEditor',
  components: {
    quillEditor,
  },
})
export default class RichTextEditor extends Vue {
  // 使用 Class 属性直接定义 data，TS 会自动推导类型

  @lazyInject(UserService)
  protected userService!: UserService;

  @Model('change')
  value!: any;

  // eslint-disable-next-line
  content: any =
    '<h2>服务流程</h2><p><br></p><p><br></p><p><br></p><h2>服务信息</h2><p><br></p><p><br></p><p><br></p><h2>服务示例</h2><p><br></p><p><br></p><p><br></p><h2>购买须知</h2><p><br></p><p><br></p><p><br></p>';

  @Watch('content')
  onContentChange() {
    // console.log('内容变化了', val);
    this.$emit('update', this.content);
  }

  // 定义编辑器配置
  editorOption = {
    theme: 'snow',
    modules: {
      toolbar: {
        container: [
          ['bold', 'italic', 'underline', 'strike'],
          [
            { header: [1, 2, 3, false] },
            { size: ['12px', '14px', '16px', '18px', '20px', '24px', '32px'] },
          ],
          [{ list: 'ordered' }, { list: 'bullet' }, { align: [] }],
          ['image'],
          [{ color: [] }, { background: [] }],
        ],
        // 重写 image 按钮的点击事件
        handlers: {
          image: () => {
            // 使用箭头函数后，这里的 this 依然指向当前的 Vue Class 实例
            // 所以可以直接通过 this.$refs 获取隐藏的 input 并触发点击
            (this.$refs.imgInput as HTMLInputElement).click();
          },
        },
      },
      imageResize: {
        displayStyles: {
          backgroundColor: 'black',
          border: 'none',
          color: 'white',
        },
        modules: ['Resize', 'DisplaySize', 'Toolbar'],
      },
    },
  };

  // 使用 @Ref 装饰器来获取 $refs，替代 this.$refs.xxx 的魔法字符串写法
  @Ref('myQuillEditor') readonly myQuillEditor!: any;
  @Ref('imgInput') readonly imgInput!: HTMLInputElement;

  // 定义 methods，直接写成 Class 的方法即可
  async handleFileChange(e: Event) {
    const target = e.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) return;

    try {
      const imageUrl = await this.uploadImageToServer(file);

      // 直接使用上面 @Ref 声明的 myQuillEditor 属性
      const { quill } = this.myQuillEditor;
      const length = quill.getSelection().index;

      quill.insertEmbed(length, 'image', imageUrl);
      quill.setSelection(length + 1);
    } catch (error) {
      console.error('图片上传失败:', error);
    }

    // 清空 input 的值
    target.value = '';
  }

  async uploadImageToServer(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('file', file);
    try {
      // 这里使用 await 等待异步操作完成
      const response: any = await axios.post(
        `${BASE_URL}/tool/upload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            AUTHORIZATION: this.userService.currentUser()?.token || '',
          },
        },
      );
      // console.log('response', response);
      let url: any = '';
      if (response.length > 0) {
        url = response[0].url;
      }
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(url);
        }, 1000);
      });
    } catch (error) {
      console.error('上传图片失败:', error);
      throw error;
    }

    // const { data } = response;
  }

  mounted() {
    Quill.register('modules/imageResize', ImageResize);

    // 获取 Quill 内部的字号样式属性
    const SizeStyle = Quill.import('attributors/style/size');
    // 重新定义字号的白名单（必须和你工具栏里配置的完全一致）
    SizeStyle.whitelist = [
      '12px',
      '14px',
      '16px',
      '18px',
      '20px',
      '24px',
      '32px',
    ];
    // 将修改后的白名单重新注册到 Quill 中，true 表示覆盖原有的
    Quill.register(SizeStyle, true);
    this.$nextTick(() => {});
    this.watchValue();
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.content = this.value;
      // console.log('this.content', this.value);
      // this.val = this.value;
    } else {
      // this.val = '';
    }
  }
}
